exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".watchlist-dropdown>.dropdown-menu{min-width:412px}.watchlist-activity-container{max-height:600px;overflow:auto;padding:4px}.watchlist-activity-container::-webkit-scrollbar{width:8px}.watchlist-activity-container::-webkit-scrollbar-thumb{border:2px solid transparent}.watchlist-counter{background:var(--primary);font-weight:600;position:absolute;top:-8px;right:-8px;color:#fff;height:14px;width:14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:50%;font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d4789a5","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/views/rd/assets/js/v2/components/watchlist/watchlistDropdown.vue
// module id = C+Ft
// module chunks = 11 18 32